export interface IAchPaymentProfile {
        routingNumber: string;
        accountNumber: string;
        accountName: string;
    }

    export class AchPaymentProfile implements IAchPaymentProfile {
        routingNumber: string;
        accountNumber: string;
        accountName: string;
    }